import { Stack as MuiStack } from '@mui/material';
import { shouldNotForwardProps } from '../../helpers';
import { styled } from '../muiReexports';
const justifyMap = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end',
};
export const StackStyled = styled(MuiStack, shouldNotForwardProps('align'))(({ align }) => ({
    ...(align && {
        justifyContent: justifyMap[align],
    }),
}));
